tinymce.Resource.add('tinymce.html-i18n.help-keynav.th-TH',
'<h1>เริ่มต้นการนำทางด้วยแป้นพิมพ์</h1>\n' +
  '\n' +
  '<dl>\n' +
  '  <dt>โฟกัสที่แถบเมนู</dt>\n' +
  '  <dd>Windows หรือ Linux: Alt+F9</dd>\n' +
  '  <dd>macOS: &#x2325;F9</dd>\n' +
  '  <dt>โฟกัสที่แถบเครื่องมือ</dt>\n' +
  '  <dd>Windows หรือ Linux: Alt+F10</dd>\n' +
  '  <dd>macOS: &#x2325;F10</dd>\n' +
  '  <dt>โฟกัสที่ส่วนท้าย</dt>\n' +
  '  <dd>Windows หรือ Linux: Alt+F11</dd>\n' +
  '  <dd>macOS: &#x2325;F11</dd>\n' +
  '  <dt>โฟกัสไปที่การแจ้งเตือน</dt>\n' +
  '  <dd>Windows หรือ Linux: Alt+F12</dd>\n' +
  '  <dd>macOS: &#x2325;F12</dd>\n' +
  '  <dt>โฟกัสที่แถบเครื่องมือตามบริบท</dt>\n' +
  '  <dd>Windows, Linux หรือ macOS: Ctrl+F9</dd>\n' +
  '</dl>\n' +
  '\n' +
  '<p>การนำทางจะเริ่มที่รายการ UI แรก ซึ่งจะมีการไฮไลต์หรือขีดเส้นใต้ไว้ในกรณีที่รายการแรกอยู่ใน\n' +
  '  พาธองค์ประกอบส่วนท้าย</p>\n' +
  '\n' +
  '<h1>การนำทางระหว่างส่วนต่างๆ ของ UI</h1>\n' +
  '\n' +
  '<p>ในการย้ายจากส่วน UI หนึ่งไปยังส่วนถัดไป ให้กด <strong>Tab</strong></p>\n' +
  '\n' +
  '<p>ในการย้ายจากส่วน UI หนึ่งไปยังส่วนก่อนหน้า ให้กด <strong>Shift+Tab</strong></p>\n' +
  '\n' +
  '<p>ลำดับ<strong>แท็บ</strong>ของส่วนต่างๆ ของ UI คือ:</p>\n' +
  '\n' +
  '<ol>\n' +
  '  <li>แถบเมนู</li>\n' +
  '  <li>แต่ละกลุ่มแถบเครื่องมือ</li>\n' +
  '  <li>แถบข้าง</li>\n' +
  '  <li>พาธองค์ประกอบในส่วนท้าย</li>\n' +
  '  <li>ปุ่มสลับเปิด/ปิดจำนวนคำในส่วนท้าย</li>\n' +
  '  <li>ลิงก์ชื่อแบรนด์ในส่วนท้าย</li>\n' +
  '  <li>จุดจับปรับขนาดของตัวแก้ไขในส่วนท้าย</li>\n' +
  '</ol>\n' +
  '\n' +
  '<p>หากส่วน UI ไม่ปรากฏ แสดงว่าถูกข้ามไป</p>\n' +
  '\n' +
  '<p>หากส่วนท้ายมีการโฟกัสการนำทางแป้นพิมพ์และไม่มีแถบข้างปรากฏ การกด <strong>Shift+Tab</strong>\n' +
  '  จะย้ายการโฟกัสไปที่กลุ่มแถบเครื่องมือแรก ไม่ใช่สุดท้าย</p>\n' +
  '\n' +
  '<h1>การนำทางภายในส่วนต่างๆ ของ UI</h1>\n' +
  '\n' +
  '<p>ในการย้ายจากองค์ประกอบ UI หนึ่งไปยังองค์ประกอบส่วนถัดไป ให้กดปุ่ม<strong>ลูกศร</strong>ที่เหมาะสม</p>\n' +
  '\n' +
  '<p>ปุ่มลูกศร<strong>ซ้าย</strong>และ<strong>ขวา</strong></p>\n' +
  '\n' +
  '<ul>\n' +
  '  <li>ย้ายไปมาระหว่างเมนูต่างๆ ในแถบเมนู</li>\n' +
  '  <li>เปิดเมนูย่อยในเมนู</li>\n' +
  '  <li>ย้ายไปมาระหว่างปุ่มต่างๆ ในกลุ่มแถบเครื่องมือ</li>\n' +
  '  <li>ย้ายไปมาระหว่างรายการต่างๆ ในพาธองค์ประกอบของส่วนท้าย</li>\n' +
  '</ul>\n' +
  '\n' +
  '<p>ปุ่มลูกศร<strong>ลง</strong>และ<strong>ขึ้น</strong></p>\n' +
  '\n' +
  '<ul>\n' +
  '  <li>ย้ายไปมาระหว่างรายการเมนูต่างๆ ในเมนู</li>\n' +
  '  <li>ย้ายไปมาระหว่างรายการต่างๆ ในเมนูป๊อบอัพแถบเครื่องมือ</li>\n' +
  '</ul>\n' +
  '\n' +
  '<p>ปุ่ม<strong>ลูกศร</strong>จะเลื่อนไปมาภายในส่วน UI ที่โฟกัส</p>\n' +
  '\n' +
  '<p>ในการปิดเมนูที่เปิดอยู่ เมนูย่อยที่เปิดอยู่ หรือเมนูป๊อบอัพที่เปิดอยู่ ให้กดปุ่ม <strong>Esc</strong></p>\n' +
  '\n' +
  '<p>หากโฟกัสปัจจุบันอยู่ที่ ‘ด้านบนสุด’ ของส่วน UI เฉพาะ การกดปุ่ม <strong>Esc</strong> จะทำให้ออกจาก\n' +
  '  การนำทางด้วยแป้นพิมพ์ทั้งหมดเช่นกัน</p>\n' +
  '\n' +
  '<h1>การดำเนินการรายการเมนูหรือปุ่มในแถบเครื่องมือ</h1>\n' +
  '\n' +
  '<p>เมื่อไฮไลต์รายการเมนูหรือปุ่มในแถบเครื่องมือที่ต้องการ ให้กด <strong>Return</strong>, <strong>Enter</strong>\n' +
  '  หรือ <strong>Space bar</strong> เพื่อดำเนินการรายการดังกล่าว</p>\n' +
  '\n' +
  '<h1>การนำทางสำหรับกล่องโต้ตอบที่ไม่อยู่ในแท็บ</h1>\n' +
  '\n' +
  '<p>ในกล่องโต้ตอบที่ไม่อยู่ในแท็บ จะโฟกัสที่ส่วนประกอบเชิงโต้ตอบแรกเมื่อกล่องโต้ตอบเปิด</p>\n' +
  '\n' +
  '<p>นำทางระหว่างส่วนประกอบเชิงโต้ตอบต่างๆ ของกล่องโต้ตอบ โดยการกด <strong>Tab</strong> หรือ <strong>Shift+Tab</strong></p>\n' +
  '\n' +
  '<h1>การนำทางสำหรับกล่องโต้ตอบที่อยู่ในแท็บ</h1>\n' +
  '\n' +
  '<p>ในกล่องโต้ตอบที่อยู่ในแท็บ จะโฟกัสที่ปุ่มแรกในเมนูแท็บเมื่อกล่องโต้ตอบเปิด</p>\n' +
  '\n' +
  '<p>นำทางระหว่างส่วนประกอบเชิงโต้ตอบต่างๆ ของแท็บกล่องโต้ตอบนี้โดยการกด <strong>Tab</strong> หรือ\n' +
  '  <strong>Shift+Tab</strong></p>\n' +
  '\n' +
  '<p>สลับไปยังแท็บกล่องโต้ตอบอื่นโดยการเลือกโฟกัสที่เมนูแท็บ แล้วกดปุ่ม<strong>ลูกศร</strong>ที่เหมาะสม\n' +
  '  เพื่อเลือกแท็บที่ใช้ได้</p>\n');